export class TechReviewQuery {
    constructor(public UN?, public TStat?, public Period?, public FromDate?, public ToDate?) { }
}